import React, { useState } from 'react';
import Bouton from '../../../../UI/Bouton/Bouton';
import { unixTimestampToDate } from 'ressources/functionJS/unixTimestampToDate';
import { checkMot } from 'ressources/functionJS/checkMot';

const SelectionDateForUnixTimestamp = ({ defaultValue, value, onUpdate }) => {
  const [defaultDate] = useState(() => {
    return defaultValue && defaultValue.length > 0
      ? unixTimestampToDate(defaultValue).split(', ')[0].split('/')
      : '';
  });

  const [defaultTime] = useState(() => {
    return defaultValue && defaultValue.length > 0
      ? unixTimestampToDate(defaultValue).split(', ')[1].split(':')
      : '';
  });

  const [date, setDate] = useState(() => {
    return unixTimestampToDate(value) !== null
      ? unixTimestampToDate(value).split(', ')[0].split('/').reverse().join('-')
      : null;
  });

  const [time, setTime] = useState(() => {
    return unixTimestampToDate(value) !== null
      ? unixTimestampToDate(value).split(', ')[1]
      : null;
  });

  const gereDate = (event) => {
    setDate(event.target.value);
  };

  const gereTime = (event) => {
    setTime(event.target.value);
  };

  const envoiDate = () => {
    if (date !== undefined && date !== null) {
      const splitDate = date.split('-');
      const splitHour = time.split(':');

      //fuseau horaire
      let valeurFuseau = new Date().getTimezoneOffset() / 60;

      //date
      //  les mois sont compris entre 0 and 11 (January to December).
      //  Les heures sont comprises entre 0 et 23 (00h pour minuit et 23h)
      let datum = new Date(
        Date.UTC(
          splitDate[0],
          parseInt(splitDate[1]) - 1,
          splitDate[2],
          parseInt(splitHour[0]) + valeurFuseau,
          splitHour[1],
          '00'
        )
      );
      //conversion en uts
      const timeToUnix = datum.getTime();
      onUpdate(timeToUnix / 1000);
    } else {
      onUpdate(null);
    }
  };

  return [
    <input
      key="date"
      type="date"
      defaultValue={`${defaultDate[2]}-${defaultDate[1]}-${defaultDate[0]}`}
      onChange={gereDate}
    />,
    <input
      key="time"
      type="time"
      defaultValue={`${defaultTime[0]}:${defaultTime[1]}`}
      onChange={gereTime}
    />,
    <Bouton key="save" cliquer={envoiDate}>
      {checkMot('enregistrer')}
    </Bouton>,
    <Bouton key="null" cliquer={() => onUpdate(null)}>
      {checkMot('envoi_null')}
    </Bouton>,
  ];
};

export default SelectionDateForUnixTimestamp;
